import React from "react";

const RadioInput = ({ name, value, checked, onChange, label, className }) => {
  return (
    <div className={`input-group ${className ? className : ""}`}>
      <label>
        <input
          className="scale-[1.5] mr-[15px] cursor-pointer"
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        {label}
      </label>
    </div>
  );
};

export default RadioInput;
